import React from 'react'
import { usePaymentStore } from 'stores/paymentStore'
import AddCreditCard from '../forms/AddCreditCard'
import SleepSelectOption from '../../components/SleepSelectOption'
import SfRadio from 'components/overrides/SfRadio'

const CreditCard: React.FC = () => {
  const { selectedPaymentProfile, setSelectedPaymentProfile } = usePaymentStore()
  const isSelected = selectedPaymentProfile === `New Credit Card`

  return (
    <SleepSelectOption
      selected={isSelected}
      onClick={() => setSelectedPaymentProfile( `New Credit Card` )}
      data-testid="snl-sleep-select-new-card"
    >
      <div className="flex items-center gap-2">
        <SfRadio
          checked={isSelected}
          readOnly
          onChange={() => {
            // Radio state is managed by parent component's onClick handler
            // This empty handler prevents React warnings for controlled inputs
          }}
        />
        <p className="font-light">{`Pay by credit card`}</p>
      </div>
      {isSelected && <AddCreditCard />}
    </SleepSelectOption>
  )
}

export default CreditCard